module.exports = __webpack_public_path__ + "static/media/rectangle-landscape.ef17b5ed.svg";